import React from 'react';

export const getEnrolmentColumns = ({ t }) => [
  {
    key: 'projectName',
    title: t('forms:projectName.label'),
    render: (_, { context: { projectId } }) => {
      const hasError = !projectId;

      return (
        <span className={`${hasError ? 'text-danger-500' : ''}`}>
          {projectId || 'None assigned'}
        </span>
      );
    },
  },
  {
    key: 'recipientInformation',
    title: t('forms:recipientInformation.label'),
    render: (_, { patientId, context: { patientName } }) => {
      const hasPatientNameError = !patientName;
      const hasPatientIdError = !patientId;

      return (
        <div className="stack-0">
          <span className={`${hasPatientNameError ? 'text-danger-500' : ''}`}>
            {patientName || 'None assigned'}
          </span>
          <span
            className={`text-xs ${
              hasPatientIdError ? 'text-danger-500' : 'text-secondary'
            }`}
          >
            ID: {patientId || 'None assigned'}
          </span>
        </div>
      );
    },
  },
];
